import { getOrCreateDeviceId } from "../helpers/device";

export const API_BASE =
    process.env.REACT_APP_API_BASE || "http://localhost:3000/api";

// MEDIA ma iść bez /api:
export const MEDIA_BASE =
    process.env.REACT_APP_MEDIA_BASE || 'http://localhost:3000/api';

// helper (polecam używać wszędzie)
export const toMediaUrl = (p?: string | null) => {
    if (!p) return null;
    if (/^https?:\/\//i.test(p)) return p;
    const clean = String(p).replace(/^\/+/, "");
    return `${MEDIA_BASE}/media/${clean}`;
};

export const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    const deviceId = getOrCreateDeviceId();
    const deviceName = navigator.userAgent;

    return {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "X-Device-Id": deviceId,
        "X-Device-Name": deviceName,
    };
};
